<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 21:53:52
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
        <div class="pageTitle">退货管理</div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" style="margin: 20px;">
            <el-form-item label="退货时间:" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time" style="width: 100%;"
                                    clearable></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time" style="width: 100%;"
                                    clearable></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="退货单号:">
                <el-input v-model="form.return_goods_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否赠品:">
                <el-select v-model="form.isgift">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option key="1" label="赠品" value="1"></el-option>
                    <el-option key="2" label="非赠品" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品编号:">
                <el-input v-model="form.product_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品名称:">
                <el-input v-model="form.product_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产批次号:">
                <el-input v-model="form.production_batch" clearable></el-input>
            </el-form-item>
            <el-form-item label="审核状态:" prop="status">
                <el-select v-model="form.status" placeholder="请选择活动区域">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option key="1" label="未审核" value="1"></el-option>
                    <el-option key="2" label="审核通过" value="2"></el-option>
                    <el-option key="3" label="审核不通过" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="经销商/门店:">
                <el-col :span="12">
                    <el-input v-model="form.to_sn" clearable readonly></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectType()">选择</el-button>
                </el-col>
            </el-form-item>

            <el-form-item label="是否窜货:" prop="region">
                <el-select v-model="form.is_feeling_goods" placeholder="请选择活动区域">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option key="0" label="未窜货" value="0"></el-option>
                    <el-option key="1" label="已窜货" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="退往仓库:" prop="region">
                <el-select v-model="form.warehouse_sn" clearable>
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                               :value="i.warehouse_sn"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
            </el-form-item>
        </el-form>
        <!--表格-->
        <!-- <el-table
                 ref="multipleTable"
                 :data="tableData"
                 height="350"
                 border
                 stripe
                 style="width: 100%">
             <el-table-column
                     label="序号"
                     width="80"
                     type="index"
                     fixed
             >
             </el-table-column>
             <el-table-column
                     prop="instockCode"
                     label="退货单号"
                     width="120"
                     fixed>
             </el-table-column>
             <el-table-column
                     prop="pCode"
                     label="快递单号"
                     width="120"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="instockNum"
                     width="180"
                     label="日期"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="num"
                     label="退往单位"
                     width="180"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="退货经销商/门店编号"
                     width="240"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="退货经销商/门店名称"
                     width="240"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="退往仓库"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="审核状态"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="退货总数"
                     width="180"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop=pName""
                     label="生产批次号"
                     width="180"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop=pName""
                     label="退货数量"
                     width="180"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="产品编号"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="产品名称"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="规格"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="单位"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="是否赠品"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="条码"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="生产日期"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop="pName"
                     label="有效期至"
                     show-overflow-tooltip>
             </el-table-column>
             <el-table-column
                     prop=""
                     label="操作"
                     width="240"
                     show-overflow-tooltip>
                 <template slot-scope="scope">
                     <el-button type="text" size="small" @click="print()">打印</el-button>
                     <el-button type="text" size="small" @click="deliver()">快递单号</el-button>
                     <el-button type="text" size="small" @click="edit()">变更审核</el-button>
                     <el-button type="text" size="small" @click="del()">删除</el-button>
                 </template>
             </el-table-column>
         </el-table>-->
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px"
      border
      fit
       max-height="500"
      >
    <!-- //   <el-table-column prop="id" label="序号" sortable fixed="left"></el-table-column> -->
      <el-table-column prop="return_goods_sn" label="退货单号" fixed="left" width="180"></el-table-column>
      <el-table-column prop="express_sn" label="快递单号" fixed="left" width="180"></el-table-column>
      <el-table-column prop="created_at" label="日期" width="180"></el-table-column>
      <el-table-column prop="to_name" label="退往单位" width="180"></el-table-column>
      <el-table-column prop="from_sn" label="经销商/门店编号"  width="180"></el-table-column>
      <el-table-column prop="from_name" label="经销商/门店名称"  width="180"></el-table-column>
      <el-table-column prop="warehouse_name" label="退往仓库"  width="180"></el-table-column>
      <el-table-column prop="total_stock_out_num" label="审核状态"  width="180">
      <template slot-scope="scope">
            <span v-if="scope.row.verify_status == 1">未审核</span>
            <span v-if="scope.row.verify_status == 2">审核通过</span>
            <span v-if="scope.row.verify_status == 3">审核不通过</span>
          </template>
      </el-table-column>
      <el-table-column prop="return_goods_num_total" label="退货总数" width="180"></el-table-column>
      <el-table-column prop="product_sn" label="产品编号" width="180"></el-table-column>
      <el-table-column prop="product_name" label="产品名称" width="180"></el-table-column>
      <el-table-column prop="production_specs" label="规格" width="180"></el-table-column>
      <el-table-column prop="production_unit" label="单位"></el-table-column>
      <el-table-column prop="production_batch" label="生产批次号" width="180"></el-table-column>
      <el-table-column prop="real_return_goods_num" label="退货数量"></el-table-column>
      <el-table-column prop="production_date" label="生产日期" width="180" ></el-table-column>
      <el-table-column prop label="是否赠品" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.isgift == 1">赠品</span>
          <span v-if="scope.row.isgift == 2">非赠品</span>
        </template>
      </el-table-column>
      <el-table-column prop="production_bar_code" label="条码" width="180">
      </el-table-column>
      <el-table-column prop="expiring_date" label="有效期至" fixed="right" width="180" >
      </el-table-column>
      <el-table-column prop="" label="操作" fixed="right" width="220">
        <template slot-scope="scope">
         <el-button type="text" size="small" @click="print(scope.row)">打印</el-button>
        <el-button type="text" size="small" @click="deliver(scope.row)">快递单号</el-button>
        <el-button type="text" size="small" @click="edit(scope.row)">退货审核</el-button>
        <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

        <!-- <div class="tableBox" v-loading="loading">

            <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 40px;">序号</th>
                    <th style="width: 140px">退货单号</th>
                    <th style="width: 120px">快递单号</th>
                    <th style="width: 120px">日期</th>
                    <th style="width: 120px">退往单位</th>
                    <th style="width: 240px">经销商/门店编号</th>
                    <th style="width: 220px">经销商/门店名称</th>
                    <th style="width: 120px">退往仓库</th>
                    <th style="width: 120px">审核状态</th>
                    <th style="width: 120px">退货总数</th>
                    <th style="width: 160px">产品编号</th>
                    <th style="width: 180px">产品名称</th>
                    <th style="width: 120px">规格</th>
                    <th style="width: 120px">单位</th>
                    <th style="width: 120px">生产批次号</th>
                    <th style="width: 160px">退货数量</th>
                    <th style="width: 180px">生产日期</th>
                    <th style="width: 120px">是否赠品</th>
                    <th style="width: 180px">条码</th>
                    <th style="width: 100px;">有效期至</th>
                    <th style="width: 200px;">操作</th>
                </tr>
                </thead>
                <tbody >
           
                <template v-for="(item,index) in tableData">
                    <template v-for="(val,num) in item.return_goods">
                        <tr>
                            <template v-if="item.return_goods.length > 0 && num > 0">
                                <td colspan="10"></td>
                            </template>
                            <template v-else>
                                <td style="white-space: nowrap;">{{item.id}}</td>
                                <td style="white-space: nowrap;">{{item.return_goods_sn}}</td>
                                <td style="white-space: nowrap;">{{item.express_sn}}</td>
                                <td style="white-space: nowrap;">{{item.created_at}}</td>
                                <td style="white-space: nowrap;">{{item.to_name}}</td>
                                <td style="white-space: nowrap;">{{item.from_sn}}</td>
                                <td style="white-space: nowrap;">{{item.from_name}}</td>
                                <td style="white-space: nowrap;">{{item.warehouse_name}}</td>
                                <td style="white-space: nowrap;">
                                    <span v-if="item.verify_status == 1">未审核</span>
                                    <span v-if="item.verify_status == 2">审核通过</span>
                                    <span v-if="item.verify_status == 3">审核不通过</span>
                                </td>
                                <td style="white-space: nowrap;">{{item.return_goods_num_total}}</td>
                            </template>
                            <td style="white-space: nowrap;">{{val.product_sn}}</td>
                            <td style="white-space: nowrap;">{{val.product_name}}</td>
                            <td style="white-space: nowrap;">{{val.production_specs}}</td>
                            <td style="white-space: nowrap;">{{val.production_unit}}</td>
                            <td style="white-space: nowrap;">{{val.production_batch}}</td>
                            <td style="white-space: nowrap;">
                                <span style="color: red;cursor: pointer" @click="deliverCode(item)">{{val.real_return_goods_num}}</span>
                            </td>
                            <td style="white-space: nowrap;">{{val.production_date}}</td>
                            <td style="white-space: nowrap;">
                                <span v-if="val.isgift == 1">赠品</span>
                                <span v-else>非赠品</span>
                            </td>
                            <td style="white-space: nowrap;">{{val.production_bar_code}}</td>
                            <td style="white-space: nowrap;">{{val.expiring_date}}</td>
                            <td style="white-space: nowrap;">
                                <el-button type="text" size="small" @click="print(item)">打印</el-button>
                                <el-button type="text" size="small" @click="deliver(item)">快递单号</el-button>
                                <el-button type="text" size="small" @click="edit(item)">退货审核</el-button>
                                <el-button type="text" size="small" @click="del(item)">删除</el-button>
                            </td>
                        </tr>
                    </template>
                </template>

                </tbody>
            </table>
        </div> -->
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
        @pushData="getInfo">
        </selectRole>
        <!--物流码明细-->
        <deliverCodeDialog
                v-if="deliverCodeDialog"
                v-on:handleClose = 'deliverCodeDialog = false'
                :return_goods_sn="return_goods_sn">

        </deliverCodeDialog>
        <!--快递单号修改-->
        <deliverDialog
                v-if="deliverDialog"
                v-on:handleClose='deliverDialog = false'
                :pushData="deliverData"
                @refresh="onSearch">
            >
        </deliverDialog>
        <!--变更审核-->
        <editDialog
                v-if="editDialog"
                v-on:handleClose='editDialog = false'
                :pushData="deliverData"
                @refresh="onSearch"
        >
        </editDialog>
    </div>
</template>

<script>
    import deliverCodeDialog from './deliverCode'
    import selectRole from '../../common/selectRole';
    import deliverDialog from './deliver';
    import editDialog from './edit';
import handlerTable from '@/until/handlerTable'

    export default {
        name: "refund-manage",
        data() {
            return {
                loading:false,
                deliverCodeDialog:false,
                selectRoleDialog: false,
                deliverDialog: false,
                editDialog: false,
                form: {
                    start_time: '',
                    end_time: '',
                    return_goods_sn: '',
                    isgift: '',
                    product_sn: '',
                    product_name: '',
                    production_batch: '',
                    is_feeling_goods: '',
                    to_sn: '',
                    to_type: '',
                    status: '',
                    warehouse_sn: ''
                },
                tableData: [],
                stockArray: [],//仓库
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                return_goods_sn:'',//组件传参
                deliverData:{},//快递单号


            }
        },
        methods:
            {
                getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }

                    dateObj.now = year + '-' + month + '-' + day;

                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }

                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }

                },
                //获取仓库
                getStock() {
                    this.$get('logistics', '/warehouses.all', {
                        lang: ''
                    }).then(res => {
                        this.stockArray = res.data;
                    }).catch(function (error) {
                    });
                },
                //选择经销商/门店
                getInfo(val){
                    if(val.dealer_sn){
                        this.form.to_type = 2;
                        this.form.to_sn = val.dealer_sn;
                    }else{
                        this.form.to_type = 3;
                        this.form.to_sn = val.shop_sn;
                    }
                },
                //获取列表数据
                onSearch() {
                    let beginstr = '', endstr = '';
                    if (this.form.start_time) {
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
                    }
                    if (this.form.end_time) {
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
            
                    this.loading = true;
                    this.$get('logistics', '/returngoods', {
                        lang: '',
                        start_time: beginstr,
                        end_time: endstr,
                        return_goods_sn: this.form.return_goods_sn,
                        product_sn: this.form.product_sn,
                        production_batch: this.form.production_batch,
                        product_name: this.form.product_name,
                        warehouse_sn: this.form.warehouse_sn,
                        to_sn: this.form.to_sn,
                        to_type: this.form.to_type,
                        status: this.form.status,
                        isgift: this.form.isgift,
                        is_feeling_goods: this.form.is_feeling_goods,
                        per_page: this.pageSize,
                        page: this.pageNo
                    }).then(res => {
                        this.loading = false;
                        //console.log(res);
                        // this.tableData = res.data;
                            this.tableData = handlerTable(res.data,{
                                    keys:'return_goods'
                                })
                        this.totalSize = res.meta.total;
                    }).catch(function () {
                    //    this.loading = false;
                    });
                },
                //选择经销商/门店
                selectType() {
                    this.selectRoleDialog = true;
                },
                //导出
                exportData(){
                    let beginstr = '', endstr = '';
                    if(this.form.start_time){
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    let url = '',access_tokens = localStorage.getItem('access_tokens');
                    window.open( this.$Base_Export+'/returngoods.export?start_time=' + beginstr +'&is_export=1'+'&end_time=' + endstr + '&is_export =1'+ '&product_sn=' +
                        this.form.product_sn +'&return_goods_sn=' + this.form.return_goods_sn + '&production_batch=' + this.form.production_batch+
                        '&product_name=' +this.form.product_name + '&lang=' + '' +'&warehouse_sn=' +this.form.warehouse_sn +'&to_type=' +
                        this.form.to_type + '&to_sn='+ this.form.to_sn + '&status='+ this.form.status +  '&isgift='+ this.form.isgift + '&is_feeling_goods=' +
                        this.form.is_feeling_goods+'&signature='+ this.$md5(access_tokens)

                    )
                },
                //物流码明细
                deliverCode(item){
                    this.return_goods_sn = item.return_goods_sn;
                    this.deliverCodeDialog = true;
                },
                //打印
                print(item) {
                    this.$router.push({
                        name: 'printRefund',
                        query:{
                            return_goods_sn:item.return_goods_sn
                        }
                    });
                },
                //快递单号
                deliver(item) {
                    this.deliverData = item;
                    this.deliverDialog = true;

                },
                //变更审核
                edit(item) {
                    if(item.verify_status !== 1){
                        this.$message({
                            type: 'error',
                            message: '已审核的数据不能重复审核！'
                        });
                        return;
                    }
                    this.deliverData = item;
                    this.editDialog = true;
                },
                //删除
                del(item) {
                    //已经审核的退货单不允许删除
                    if(item.verify_status !== 1){
                        this.$message.error('已经审核的退货单不可以删除！');
                        return;
                    }
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let url = '/returngoods/' + item.return_goods_sn;
                        this.$delete('logistics',url, {
                        }).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.onSearch();
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },


            },
        created() {
            this.form.start_time = this.getLastMonth().last;
            this.form.end_time = this.getLastMonth().now;
            this.getStock();
            this.onSearch();
        },
        components: {
            selectRole, deliverDialog, editDialog,deliverCodeDialog
        }
    }
</script>

<style lang="scss" scoped>
    .tableBox {
        overflow-x: scroll;
        min-height: 300px;
   
        .table {
            width: 300%;
        }
    }
</style>